import {languageRecord} from '@px/const/languages';

const LANG_MAP = {
  cn: 'zh',
};

export const langUtil = {
  getLanguageKey(lang) {
    return LANG_MAP[lang] || lang;
  },
  parsePathname(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length < 1) {
      return {lang: 'en', pathname: '/'};
    }

    const segment = segments[0];
    if (languageRecord.hasOwnProperty(segment)) {
      return {lang: segment, pathname: '/' + segments.slice(1).join('/')};
    }
    return {lang: 'en', pathname: '/' + segments.join('/')};
  },
};
